module.exports = __webpack_public_path__ + "static/media/bipedRobot.ab58994b.mp4";